import { VALIDATION_ERRORS } from '../constants';
import errorsFactory from '../../../utils/errorsFactory';

export default (sheetAsJson, { currentPeriod }) => {
  const havePriorPeriods = sheetAsJson.some(row => row.periodName !== currentPeriod.name);

  if (havePriorPeriods) {
    throw errorsFactory.ValidationError(VALIDATION_ERRORS.PRIOR_PERIOD_ERROR());
  }
};
